<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.COUNTRY.SELECT"
    :handler="() => $refs.modal.show()"
  />

  <VBusHelper
    :reactOn="$constants.EVENTS.COUNTRY.SELECTED"
    :handler="() => $refs.modal.hide()"
  />

  <DialogComponent ref="modal" type="fullscreen" noInnerPadding hideCloseButton>
    <div
      class="w-full h-full flex flex-col overflow-auto p-4 gap-2 bg-slate-50"
    >
      <div class="mobile-status-padding"></div>
      <button
        class="w-12 h-12 mb-2 p-3 rounded-full bg-slate-200"
        @click="() => $refs.modal.hide()"
      >
        <ColorImg
          class="w-full h-full bg-primary -rotate-90"
          src="/images/all/arrow-up.svg"
        />
      </button>
      <div class="text-primary text-4xl pr-8 mb-5">
        {{
          $stores.country?.state?.countryChoiceConf?.title ||
          'Sélectionnez le pays avec lequel continuer'
        }}
      </div>

      <div class="h-full overflow-auto flex flex-col gap-6">
        <div
          class="text-primary-200 mb-5"
          v-if="$stores.country?.state?.countryChoiceConf?.description"
        >
          {{ $stores.country?.state?.countryChoiceConf?.description || '' }}
        </div>

        <div
          class="mb-4"
          v-if="$stores.country?.state?.countryChoices?.length > 15"
        >
          <input
            type="search"
            placeholder="Rechercher un pays"
            v-model="$stores.country.state.countrySearch"
            class="inputComponent"
          />
        </div>

        <div
          v-for="country in $stores.country?.state?.countryChoices"
          v-show="
            `${(country?.name || '').toLowerCase()}`.includes(
              `${$stores.country?.state.countrySearch || ''}`
                .toLowerCase()
                .trim()
            )
          "
        >
          <div
            @click="
              () => {
                $bus.emit($constants.EVENTS.COUNTRY.SELECTION_CLICKED, country);
                if ($stores.country.state?.countryChoiceConf?.selectOnClick)
                  $bus.emit($constants.EVENTS.COUNTRY.SELECTION_CONFIRMED);
              }
            "
            class="flex items-center gap-4 p-4 rounded-2xl border border-transparent cursor-pointer transition-all bg-white"
            :class="{
              'border-amber-500! ':
                $stores.country?.state?.activeChoice?.countryCode ===
                country.countryCode
            }"
          >
            <ImgComponent
              :src="country.localLogoUrl"
              :alt="country.name"
              class="w-14 h-14 object-cover border border-neutral-200 rounded-full"
            />

            <div class="flex flex-col grow">
              <div class="text-2xl text-primary">
                {{ country.name }}
              </div>

              <div class="text-lg text-neutral-500 flex gap-3">
                {{
                  $stores.country?.state?.countryChoiceConf?.optionDesc?.[
                    country.countryCode
                  ] ||
                  $stores.country?.state?.countryChoiceConf?.optionDesc
                    ?.default ||
                  `📞 +${country.phonePrefix} - ${country.currency}`
                }}
              </div>
            </div>

            <!-- ACTIVE BADGE -->
            <div
              class="w-4 h-4"
              v-if="$stores.country?.state?.countryChoiceConf?.selectOnClick"
            >
              <ColorImg
                src="/images/all/right-arrow.svg"
                class="bg-primary-200"
                alt=""
              />
            </div>
            <div
              v-else-if="
                $stores.country?.state?.activeChoice?.countryCode ===
                country.countryCode
              "
              class="text-amber-600 font-bold text-2xl"
            >
              ✓
            </div>
          </div>
        </div>

        <div class="py-4"></div>
      </div>

      <Transition name="slide-bottom">
        <div
          class="sticky bottom-0 left-0 py-4 pb-12 bg-slate-50 w-full px-8"
          v-if="$stores.country?.state?.activeChoice?.countryCode"
        >
          <button
            v-bus:EVENTS.COUNTRY.SELECTION_CONFIRMED.click
            class="buttonComponent w-full"
          >
            Continuer
          </button>
        </div>
      </Transition>
    </div>
  </DialogComponent>
</template>
